export default "__VITE_ASSET__e7584553__"